import { render } from "./TotalRow.vue?vue&type=template&id=101b7954&scoped=true&ts=true"
import script from "./TotalRow.vue?vue&type=script&lang=ts"
export * from "./TotalRow.vue?vue&type=script&lang=ts"

import "./TotalRow.vue?vue&type=style&index=0&id=101b7954&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101b7954"]])

export default __exports__